define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {

        },
        init: function () {
            document.querySelectorAll('.js-footeraccordionTrigger').forEach((elem) => {
                elem.addEventListener('click', function () {
                    elem.parentElement.classList.toggle('is-active');
                    elem.classList.toggle('is-active');
                });
            });
        }
    });
});
